import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A0A0A] text-white py-20 md:py-28"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 flex flex-col items-center text-center">
        <Logo
          variant="light"
          className="h-14 w-auto mb-8"
          data-testid="footer-logo"
        />

        <span className="accent-bar mb-8" aria-hidden="true" />

        <p
          data-testid="footer-tagline"
          className="font-serif text-xl md:text-2xl tracking-tight"
        >
          LJMG — Cabinet de conseil
        </p>

        <p
          data-testid="footer-copyright"
          className="mt-6 text-xs tracking-[0.2em] uppercase text-white/40 font-light"
        >
          © 2026 LJMG. Tous droits réservés.
        </p>

        <Link
          to="/mentions-legales"
          data-testid="footer-legal-link"
          className="mt-10 text-xs tracking-[0.15em] uppercase text-white/35 hover:text-white/80 font-light transition-colors border-b border-white/10 hover:border-white/40 pb-1"
        >
          Mentions légales
        </Link>
      </div>
    </footer>
  );
};
